export default __webpack_public_path__ + "1716da05460e711454bfe0ed21c4ecce.svg";